<template>
	<v-container >
		<v-row justify="center">
			
			<!-- Foto del artículo -->
			<v-col cols="12"  xl="4" lg="4" md="6" sm="6" xs="12">
				<v-card class="elevation-0">
					<v-img :src="fotoInicial" contain height="300" />

					<v-row align="center" justify="space-around">
						<v-col  v-for="(item,i) in fotos" :key="i">
							<v-hover v-slot:default="{ hover }" open-delay="100" >
								<v-card  :elevation="hover ? 16 : 2" @click="verImagen(item)" width="100" height="100%">
									<v-img :src="url + item.image_name" width="100%"  height="100%" contain lazy/>
								</v-card>
							</v-hover>
						</v-col>
					</v-row>

				</v-card>
			</v-col>	

			<v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
				<v-card class="pa-2 elevation-0">
					<v-card-title primary-title >
					  <h2 align="left">¡Compralo ahora!</h2>
					</v-card-title>

					<v-card-title primary-title class="primary--text">
					  <h3>{{ articulo.nomart }}</h3>
					</v-card-title>

					<v-card-text >
						<v-textarea v-model="articulo.descrip" auto-grow readonly/>
					</v-card-text>

					<div v-if="articulo.pjedesc > 0" class="secondary--text ml-4"><strike><h3>$ {{ articulo.precio1 }}  MXN</h3></strike></div>
					<div v-else class="primary--text ml-4"><h2>${{ articulo.precio1 }}  MXN</h2></div>

					<div v-if="articulo.pjedesc > 0" class="primary--text ml-4"><h2>$ {{ preciodesc }}  MXN</h2></div>

					<v-card-actions>
					  <v-btn color="primary" @click="addCarrito(articulo)"><v-icon left>shopping_cart</v-icon>Agregar a carrito</v-btn>
					</v-card-actions>

				</v-card>
			</v-col>	
		</v-row>

		<v-row justify="center">
			<v-col cols="12">
				<v-card class="elevation-0">
		  		<v-card-title primary-title>
		  			<v-spacer></v-spacer>
		  		  <h2 class="primary--text">Relacionados<v-icon right color="primary" large>eco</v-icon></h2>
		  		  <v-spacer></v-spacer>
		  		</v-card-title>
		  		<v-card-text>
				    <v-row  justify=center>
				    	<v-col 
				    		cols="12" xl="2" lg="4" md="4" sm="6" 
				    		v-for="(articulo, i) in articulos" 
				    		:key="i" 
				    		v-if="i >= countMin && i < countMax "
							>
				    		<v-hover v-slot:default="{ hover }">
				          <v-card height="100%" v-on:dblclick="verDetalle(articulo)" class="elevation-4">
				            <v-img 
				            	v-if="articulo.fotos.length > 0"
				              class="mb-4"
				              :src="url + articulo.fotos[0].image_name" 
				              height="180"
				              contain>
				            </v-img> 

				            <v-img 
				            	v-else
				              class="mb-4"
				              src="@/assets/blanco.jpg" 
				              height="180"
				              contain>
				            </v-img> 

				            <v-card-text class="py-0">
					            <h2>{{articulo.nomart}}</h2><br/>
		                  <h3>{{articulo.descrip}}</h3><br/>
				            </v-card-text>

										<v-card-actions v-if="articulo.pjedesc > 0">
		                  <strike><h4 class="primary--text mr-2">{{articulo.precio1}} MXN</h4></strike>
		                </v-card-actions>

		                <v-card-actions v-if="articulo.pjedesc > 0">
		                  <h3 class="secondary--text"><b>Oferta</b> {{ articulo.prediocesc }} MXN</h3>
		                </v-card-actions>

		                <v-card-actions v-else>
		                  <h3 class="primary--text ml-2">${{articulo.precio1}} MXN</h3>
		                </v-card-actions>

		                <v-card-actions >
											<v-btn
												color="primary"
												block
												small
												@click="addCarrito(articulo)"
											>
												Agregar al carrito
												<v-icon right>mdi-cart</v-icon>
											</v-btn>
										</v-card-actions>
		                
				          </v-card>
				        </v-hover>
				    	</v-col>

				    	<v-col cols="12" align="center">
				    		<v-pagination
						      v-model="page"
						      :length="paginas"
						    ></v-pagination>
						      <!-- :total-visible="7" -->
				    	</v-col>
				    </v-row>
		  		</v-card-text>
		  	</v-card>
			</v-col>
		</v-row>

	</v-container>
</template>

<script>
	import {mapActions} from 'vuex'
	var numeral = require('numeral');

export default {
    data:()=>({
    	fotos:[],
			fotoInicial: '',
			codigo:'',
			articulo:'',
			url:'',
			preciodesc:'',

			countMaxima: 6,
    	height:'',
			width:'',
      model:null,
      relacionados:[],

    	page: 1,
    	paginas:0,

    	sinImagen:'@/assets/blanco.jpg',

    	countMax: 3,
    	countMin: 0,

			img: 'https://teva.niceapp.cl/wp-content//uploads/2019/03/Paracetamol_Infantil_125MG_6S_HD.jpg',

      articulos:[],

    }),

    watch:{
    	$route(){
    		this.codigo = this.$route.params.codigo
        this.cargarInfo()
      },

      page(){
    		var itemPerPage = this.page * this.countMaxima
    		console.log(itemPerPage)
    		this.countMin = (itemPerPage  - this.countMaxima)
    		this.countMax = itemPerPage
    		console.log('cambie de pagina', this.page)
    	},

    	tamanioDisplay(){
    		switch (this.tamanioDisplay) {
          case 'xs':
          	this.countMax =  1
          	this.countMaxima = 1 
          break;
          case 'sm': 
          	this.countMax = 2
          	this.countMaxima = 2 
          break;
          case 'md':
          	this.countMax =  3
          	this.countMaxima = 3 
          break;
          case 'lg':
          	this.countMax =  3
          	this.countMaxima = 3 
          break;
          case 'xl':
          	this.countMax =  4
          	this.countMaxima = 4
          break;
        }
    	}
    },

    created(){
				this.codigo = this.$route.params.codigo
				this.url = this.$http.options.root + 'fotos/'
				this.cargarInfo()
		},

		methods:{
			...mapActions('carrito',['carritoadd']),

			cargarInfo(){
				this.$http.get('tienda/articulos.codigo/' + this.codigo).then(response=>{
					this.articulo = response.body[0]

					if(this.articulo.pjedesc > 0 ){
						this.preciodesc = this.articulo.precio1 * (  (100 - this.articulo.pjedesc) * 0.01 ) 
						this.preciodesc = numeral(this.preciodesc).format('0,0.00')
					}

					this.articulo.precio1 = numeral(this.articulo.precio1).format('0,0.00')
					this.fotos = this.articulo.fotos 
					this.verImagen(this.fotos[0])

					this.getRelacionados(this.articulo.idlaboratorio)
				}).catch(error=>{console.log(error)})
			},

			verImagen(foto){
				this.fotoInicial = this.url + foto.image_name
			},
      
	    getRelacionados(id){
	      this.$http.get('tienda/articulos.laboratorio.get/' + id).then(response=>{
    			this.articulos = response.body
    			this.articulos.forEach((element, index)=>{
            element.prediocesc = element.precio1 * (  (100 - element.pjedesc) * 0.01 ) 
    				element.precio1 = numeral(element.precio1).format('0,0.00')
            element.prediocesc = numeral(element.prediocesc).format('0,0.00')
            if(index == (this.articulos.length-1)){
            	this.paginacion()
            }
    			})
        })
	    },

	  	adelante(){
	  		// guardamos el primer valor del arreglo 
	  		var temp = this.novedades[0]
	  		// lo eliminamos
	  		this.novedades.shift();
	  		// y agregamos al final
	  		this.novedades.push(temp); 
	  	},

	  	atras(){
	  		// guardamos el ultimo
	  		var temp = this.novedades[this.novedades.length - 1]
	  		// eliminamos el ultimo
	  		this.novedades.pop();
	  		// y agregamos al principio
	  		this.novedades.unshift(temp)
	  	},

	    addCarrito(art){
	      // art.precio1 = this.unformat(art.precio1)
	      this.carritoadd(art)
	      this.$store.state.carrito.carritovisible = true
	      art.precio1 = numeral(art.precio1).format('0,0.00')
	    },

	    unformat(string) {
        return numeral._.stringToNumber(string);
    	},

	    verDetalle(art){
				// this.codigo = art.codigo
				// this.cargarInfo(this.codigo)
				this.$router.push({ name: 'detart' , params:{ codigo:art.codigo} })
			},

      paginacion(){
	  		if((this.articulos.length /this.countMaxima)%2==0){
		    	this.paginas = this.articulos.length / this.countMaxima
	    	}else{
	    		this.paginas = parseInt((this.articulos.length / this.countMaxima) + 1)
	    	}
    	},
	  },

    computed:{
    	tamanioDisplay () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          	this.countMax =  1
          	this.countMaxima = 1 
          break;
          case 'sm': 
          	this.countMax = 2
          	this.countMaxima = 2 
          break;
          case 'md':
          	this.countMax =  3
          	this.countMaxima = 3 
          break;
          case 'lg':
          	this.countMax =  3
          	this.countMaxima = 3 
          break;
          case 'xl':
          	this.countMax =  4
          	this.countMaxima = 4
          break;
        }
      },

      filterArticulos: function(){
    		var me = this
	    	if(this.articulos){
		      return this.articulos.filter((art)=>{
		        var nom = art.nomart.toLowerCase();
		        return nom.match(this.search.toLowerCase());
		      })
	    	}
	    },
    }
  }
</script>
<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}

#titulo{
  font-family:"Palatino Linotype", "Book Antiqua", Palatino, serif;
}
</style>